module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/salerno.5855dd47524273dd330c358bfa9d3b6e.jpg";